'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: auto;\n'], ['\n  width: auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 40px;\n  border-radius: 50px;\n  background-color: ', ';\n  box-shadow: 0 10px 18px -12px ', ';\n  min-width: 250px;\n  width: auto;\n  opacity: 0;\n  color: ', ';\n  text-align: center;\n  padding: 10px;\n  position: fixed;\n  z-index: 999999999;\n  right: auto;\n  margin: 0 auto;\n  left: 50%;\n  transform: translateX(-50%);\n  display: inline-table;\n  bottom: -30px;\n  font-size: 15px;\n  line-height: 20px;\n  transition: all 0.3s ease 0s;\n'], ['\n  height: 40px;\n  border-radius: 50px;\n  background-color: ', ';\n  box-shadow: 0 10px 18px -12px ', ';\n  min-width: 250px;\n  width: auto;\n  opacity: 0;\n  color: ', ';\n  text-align: center;\n  padding: 10px;\n  position: fixed;\n  z-index: 999999999;\n  right: auto;\n  margin: 0 auto;\n  left: 50%;\n  transform: translateX(-50%);\n  display: inline-table;\n  bottom: -30px;\n  font-size: 15px;\n  line-height: 20px;\n  transition: all 0.3s ease 0s;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SnackBarContainer = _styledComponents2.default.div(_templateObject);

var SnackBar = _styledComponents2.default.div(_templateObject2, _color2.default.blue_main, _color2.default.grey_main, _color2.default.white);

var MozartSnackBar = function (_Component) {
  _inherits(MozartSnackBar, _Component);

  function MozartSnackBar() {
    _classCallCheck(this, MozartSnackBar);

    return _possibleConstructorReturn(this, (MozartSnackBar.__proto__ || Object.getPrototypeOf(MozartSnackBar)).apply(this, arguments));
  }

  _createClass(MozartSnackBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.open !== nextProps.open || this.props.message !== nextProps.message) {
        this.toggle();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.open !== nextProps.open || this.props.message !== nextProps.message;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.toggle();
    }
  }, {
    key: 'open',
    value: function open() {
      var id = this.props.id;

      var elem = document.getElementById(id);
      if (elem && elem !== null) {
        elem.style.opacity = '1';
        elem.style.bottom = '5px';
      }
    }
  }, {
    key: 'close',
    value: function close() {
      var id = this.props.id;

      var elem = document.getElementById(id);
      if (elem && elem !== null) {
        elem.style.opacity = '0';
        elem.style.bottom = '-30px';
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      var _this2 = this;

      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          onRequestClose = _props.onRequestClose;

      this.open();
      setTimeout(function () {
        _this2.close();
        if (onRequestClose) {
          onRequestClose();
        }
      }, autoHideDuration);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          style = _props2.style,
          open = _props2.open,
          message = _props2.message,
          themeId = _props2.themeId;


      return _react2.default.createElement(
        SnackBarContainer,
        { style: style, 'data-qa': this.props.testId, 'data-theme': themeId },
        open && message !== null && _react2.default.createElement(
          SnackBar,
          { id: id },
          message
        )
      );
    }
  }]);

  return MozartSnackBar;
}(_react.Component);

MozartSnackBar.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** id */
  id: _propTypes2.default.string,
  /** override style */
  style: _propTypes2.default.object,
  /** if open true snackbar is triggered */
  open: _propTypes2.default.bool,
  /** body */
  message: _propTypes2.default.string,
  /** hide after certain ms */
  autoHideDuration: _propTypes2.default.number,
  /** callback on close */
  onRequestClose: _propTypes2.default.func
};
MozartSnackBar.defaultProps = {
  id: Math.random(),
  open: false,
  autoHideDuration: 8000,
  testId: 'MozartSnackBar',
  themeId: 'MozartSnackBar'
};
exports.default = MozartSnackBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartSnackBar/MozartSnackBar.js
// module id = 2111
// module chunks = 1